var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysisBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35 8.2C8.35 7.78579 8.01421 7.45 7.6 7.45C7.18579 7.45 6.85 7.78579 6.85 8.2H8.35ZM6.85 20.2C6.85 20.6142 7.18579 20.95 7.6 20.95C8.01421 20.95 8.35 20.6142 8.35 20.2H6.85ZM4.6 1V1.75H16.6V1V0.25H4.6V1ZM20.2 4.6H19.45V16.6H20.2H20.95V4.6H20.2ZM16.6 20.2V19.45H4.6V20.2V20.95H16.6V20.2ZM1 16.6H1.75V4.6H1H0.25V16.6H1ZM4.6 20.2V19.45C3.02599 19.45 1.75 18.174 1.75 16.6H1H0.25C0.25 19.0024 2.19756 20.95 4.6 20.95V20.2ZM20.2 16.6H19.45C19.45 18.174 18.174 19.45 16.6 19.45V20.2V20.95C19.0024 20.95 20.95 19.0024 20.95 16.6H20.2ZM16.6 1V1.75C18.174 1.75 19.45 3.02599 19.45 4.6H20.2H20.95C20.95 2.19756 19.0024 0.25 16.6 0.25V1ZM4.6 1V0.25C2.19756 0.25 0.25 2.19756 0.25 4.6H1H1.75C1.75 3.02599 3.02599 1.75 4.6 1.75V1ZM7.6 8.2H6.85V20.2H7.6H8.35V8.2H7.6ZM1.6 7.6V8.35H19.6V7.6V6.85H1.6V7.6Z",
    fill: "#825DFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisBot);
export default __webpack_public_path__ + "static/media/analysis-bot.347ca166d73360f4439ea87f4366d054.svg";
export { ForwardRef as ReactComponent };